/**
 * Computes a new value by wrapping the current selection (or cursor) with prefix and suffix,
 * then calls setValue(newValue). Does not mutate the input (for controlled components).
 * @param {HTMLTextAreaElement|HTMLInputElement} input - The input/textarea element
 * @param {string} prefix - Inserted before the selection
 * @param {string} suffix - Inserted after the selection
 * @param {function(string): void} setValue - Callback with the new full value
 * @returns {{ newSelectionStart: number, newSelectionEnd: number }|null} - Selection range after the wrapped content, or null if input invalid
 */
export default function wrapSelectionAtCaret(input, prefix, suffix, setValue) {
  const tagName = (input?.tagName || '').toLowerCase();
  const isTextArea = tagName === 'textarea';
  const isText = tagName === 'input' && input.type?.toLowerCase() === 'text';
  if (!input || !(isTextArea || isText)) {
    return null;
  }

  const start = input.selectionStart;
  let end = input.selectionEnd;
  if (end < start) end = start;

  const before = input.value.substring(0, start);
  const selected = input.value.substring(start, end);
  const after = input.value.substring(end, input.value.length);
  const newValue = before + prefix + selected + suffix + after;

  setValue(newValue);

  const newSelectionStart = start + prefix.length;
  const newSelectionEnd = newSelectionStart + selected.length;
  return { newSelectionStart, newSelectionEnd };
}
